import React from 'react';
import { Form, Input } from 'antd';

const { TextArea } = Input;

interface LicenseTermsProps {
  styles: { [key: string]: string };
}

const LicenseTerms: React.FC<LicenseTermsProps> = ({ styles }) => (
  <div className={styles.stepContainer}>
    <h2 className={styles.stepTitle}>License Terms</h2>
    
    <Form.Item 
      label="Terms of Use" 
      name="terms_of_use"
      rules={[{ required: true, message: 'Please enter terms of use' }]}
      className={styles.formItem}
    >
      <TextArea 
        placeholder="Enter Terms of Use" 
        className={styles.licenseTextarea}
        rows={8}
      />
    </Form.Item>

    <Form.Item 
      label="Privacy Policy" 
      name="privacy_policy"
      rules={[{ required: true, message: 'Please enter privacy policy' }]}
      className={styles.formItem}
    >
      <TextArea 
        placeholder="Enter Privacy Policy" 
        className={styles.licenseTextarea}
        rows={8}
      />
    </Form.Item>

    <div className={styles.licensePreview}>
      <h4>License Information Preview</h4>
      <p>Both terms of use and privacy policy have been provided</p>
    </div>
  </div>
);

export default LicenseTerms;
